import React, { useState, useEffect } from 'react';
import axiosInstance from './axiosInstance';
import './AdminDashboard.css'; // Reuse the same CSS file
import './Register.css'; 

const AdminSettings = ({ showNames }) => {
    const [adminFirstName, setAdminFirstName] = useState('Admin');

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
    });

    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the specific error for the field being updated
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axiosInstance.put('/admin/profile', formData);
            if (response.status === 200) {
                setMessage('Settings updated successfully');
                setErrors({});
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Failed to update settings');
            if (error.response && error.response.data && error.response.data.errors) {
                setErrors(error.response.data.errors);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchAdminFirstName = async () => {
            try {
                const response = await axiosInstance.get('/admin/first-name');
                setAdminFirstName(response.data.first_name);
            } catch (err) {
                console.error('Failed to fetch admin first name', err);
            }
        };

        fetchAdminFirstName();
    }, []);

    return (
        <div className={`admin-dashboard-container ${showNames ? 'show-names' : ''}`}>
            <div className="mini-header">
                <h1 className="mini-header-title">Admin Settings</h1>
                <div className="mini-header-right">
                    <span className="admin-name">{adminFirstName}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                        <path fill="currentColor" d="M23 9A7 7 0 1 1 9 9a7 7 0 0 1 14 0m-2 0a5 5 0 1 0-10 0a5 5 0 0 0 10 0M7.5 18A3.5 3.5 0 0 0 4 21.5v.5c0 2.393 1.523 4.417 3.685 5.793C9.859 29.177 12.802 30 16 30s6.14-.823 8.315-2.207C26.477 26.417 28 24.393 28 22v-.5a3.5 3.5 0 0 0-3.5-3.5zM6 21.5A1.5 1.5 0 0 1 7.5 20h17a1.5 1.5 0 0 1 1.5 1.5v.5c0 1.473-.94 2.949-2.759 4.106C21.434 27.256 18.877 28 16 28s-5.434-.744-7.241-1.894C6.939 24.95 6 23.472 6 22z" />
                    </svg>
                </div>
            </div>
            <div className="dashboard-container">
                <div className="register-content">
                    <div className="register-form-container">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="first_name" className="form-label">First Name</label>
                                <input
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    className="form-input"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                />
                                {errors.first_name && <p className="error-message">{errors.first_name}</p>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="last_name" className="form-label">Last Name</label>
                                <input
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    className="form-input"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                />
                                {errors.last_name && <p className="error-message">{errors.last_name}</p>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-input"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {errors.email && <p className="error-message">{errors.email}</p>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone_number" className="form-label">Phone Number</label>
                                <input
                                    type="text"
                                    id="phone_number"
                                    name="phone_number"
                                    className="form-input"
                                    value={formData.phone_number}
                                    onChange={handleChange}
                                />
                                {errors.phone_number && <p className="error-message">{errors.phone_number}</p>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-input"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                {errors.password && <p className="error-message">{errors.password}</p>}
                            </div>
                            <div className="form-submit">
                                <button type="submit" className="form-button-settings" disabled={loading}>
                                    {loading ? 'Loading...' : 'Update Settings'}
                                </button>
                            </div>
                            {message && <p className='messagecolor'>{message}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;